<div class="content" [formGroup]="form">
  <div class="control-container">
    <glxy-form-field required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.LABEL_TYPE' | translate }}
      </glxy-label>
      <mat-select [formControl]="notificationIdControl" required="true">
        <mat-option [value]="genericNotificationID">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.GENERIC' | translate }}
        </mat-option>
        <mat-option [value]="shoppingCartAbandonedNotificationID">
          {{
            'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.ABANDONED_SHOPPING_CART'
              | translate
          }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
  </div>

  <ng-container *ngIf="notificationIdControl.value === genericNotificationID">
    <div class="control-container" [formGroup]="notificationTypesGroup">
      <div class="description subtitle">
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_TYPES.LABEL' | translate }}
      </div>
      <EXP__glxy-wrap>
        <ng-container formArrayName="notificationTypesArray">
          <div *ngFor="let option of notificationTypeOptions; let i = index">
            <mat-checkbox [formControlName]="i">
              {{ option.name | translate }}
            </mat-checkbox>
          </div>
        </ng-container>
        <mat-error
          *ngIf="
            notificationTypesArray.dirty &&
            notificationTypesArray.invalid &&
            notificationTypesArray.errors['atLeastOne']
          "
        >
          {{
            'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_TYPES.AT_LEAST_ONE_ERROR' | translate
          }}
        </mat-error>
      </EXP__glxy-wrap>
    </div>

    <div class="control-container">
      <glxy-input
        *ngIf="notificationTypes.at(1).value"
        [formControl]="subjectControl"
        label="{{ 'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.NOTIFICATION_SUBJECT' | translate }}"
        [required]="true"
      ></glxy-input>
      <glxy-form-field required="true">
        <glxy-label>
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.NOTIFICATION_MESSAGE' | translate }}
        </glxy-label>
        <textarea
          matInput
          [formControl]="bodyTextControl"
          cdkTextareaAutosize
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="8"
          placeholder="{{
            'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.NOTIFICATION_MESSAGE_PLACEHOLDER' | translate
          }}"
          [required]="true"
        ></textarea>
        <glxy-error *ngIf="bodyTextControl.hasError('required') && bodyTextControl.dirty">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.REQUIRED_FIELD' | translate }}
        </glxy-error>
      </glxy-form-field>
      <mat-hint
        class="external-hint"
        [innerHtml]="
          'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.NOTIFICATION_MESSAGE_HINT' | translate | iTrustThisHtml
        "
      ></mat-hint>
    </div>
    <div class="control-container">
      <glxy-input
        *ngIf="notificationTypes.at(1).value"
        [formControl]="buttonTextControl"
        label="{{ 'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.BUTTON_TEXT' | translate }}"
        [required]="true"
      ></glxy-input>
      <glxy-input
        [formControl]="linkTemplateControl"
        label="{{ 'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.LINK' | translate }}"
        [required]="true"
        [validators]="linkValidators"
      ></glxy-input>
      <mat-hint
        class="external-hint"
        [innerHtml]="
          'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.LINK_HELP_TEXT'
            | translate
              : {
                  userType:
                    ('AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.USER_TYPES.USERS' | translate | automataCapitalize)
                }
            | iTrustThisHtml
        "
      ></mat-hint>
      <mat-hint
        class="external-hint"
        [innerHtml]="
          'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.NOTIFICATION_MESSAGE_HINT' | translate | iTrustThisHtml
        "
      ></mat-hint>
    </div>
  </ng-container>
</div>
